<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">
                <!-- Empty State. -->
                <div class="space-y-6">
                    <div v-if="filteredKnownContacts.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Existing known contacts</div>
                        <div class="space-y-1">
                            <button
                                v-for="knownContact in filteredKnownContacts"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="knownContact"
                                @click="selectContact(knownContact, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">{{ knownContact }}</div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching contacts found.
                    </div>
                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import UiDropdown from "../../../ui/UiDropdown.vue";

export default {
    components: {UiDropdown},
    props: {
        top: Boolean,
        estimate: Object | Function,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data() {
        return {
            query: '',
        }
    },
    computed: {
        filteredKnownContacts() {
            let options = []
            this.estimate.sendLog.forEach((sendLog) => {
                if (this.matchContact(sendLog.handle)) {
                    if (options.indexOf(sendLog.handle) === -1) {
                        options.push(sendLog.handle)
                    }
                }
            })
            return options
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
        },
        matchContact(knownContact) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            return !query || query.every((token) => {
                return (knownContact).toLowerCase().includes(token);
            });
        },
        selectContact(knownContact, close) {
            this.$emit('selected:knownContact', knownContact);
            this.query = knownContact;
            close();
        },
    },
}
</script>
